<template>
  <div>
    <div class="box" style="margin: 20px auto;">
     <!-- 无限加载滚动列表 -->
     <div v-infinite-scroll="getMore"
        infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="box_list"  v-for="(item,index) in shareList" :key="index">	  
          <img class="box_list_lfimg" :src="item.image" />
				  <div class="box_list_rt">
					<div class="list_rt_tit"><span>{{ $t('Share Time') }}</span>{{item.create_time}}</div>
					<div class="list_rt_txt"><span>{{ $t('Audit status') }}</span>{{item.status == 0?$t('Pending approval'):item.status == 1?$t('Approved'):$t('Audit failed')}}</div>
					<div class="list_rt_txt" v-if="item.status == 2">
						<span>{{ $t('Reason for failure') }}</span> {{item.reason}}
					</div>
				</div>		
         	  
        </div>  
      </div>
           
	  </div>
    <empty-record v-if='shareList.length <= 0 && !isMore'></empty-record>
  </div>

</template>

<script>
import HomeCommonSearch from '../common/HomeCommonSearch'
import EmptyRecord from '../../EmptyRecord'
import { getShareOrderList } from '../../../api/giftcard'
export default {
  name: 'ShareList',
  components: {
    HomeCommonSearch,
    EmptyRecord
  },
  data() {
    return {
      loading: false, // 是否加载更多
      isMore: true,// 是否有更多
      params:{page: 0,},
      shareList: [] // 商品列表
    }
  },
  created() {

  },
  methods:{
    /*
               * getMore: 无限滚动加载
               */
    getMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getMyCardList(true)
      }
    },
    getMyCardList(ispush) {
      getShareOrderList(
        this.params
      ).then(res => {
        this.buildData(ispush, res)
      })
    },
    buildData(ispush, res) {
      if (res) {
        if (ispush) {
          this.shareList = this.shareList.concat(res.result.data)
        } else {
          this.shareList = res.result.data
        }
        if (res.result.data.length < 10) {
          this.isMore = false
        } else {
          this.isMore = true
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.cursor:hover{
  cursor: pointer;
}
.box{
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
  .box_list{
    border-bottom: 1px solid #F1F1F1;
    display: flex;
    padding: 50px 60px;
    .box_list_lfimg{
      width: 122px;
      height: 122px;
      object-fit: contain;
    }
    .box_list_rt{
      width: 800px;
      margin-left: 30px;
      .list_rt_tit{
        font-size: 18px;
        color: #000000;
        line-height: 25px;
        span{
          font-weight: bold;
          margin-right: 10px;
        }
      }
      .list_rt_txt{
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-top: 20px;
        span{
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
